import { Component, ViewChild, OnInit, AfterViewInit, OnDestroy, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { MatInput, MatFormField, MatLabel } from '@angular/material/input';
import { MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete';
import { ReplaySubject, Subject, of } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule, MatSelect } from '@angular/material/select';
import { FieldType } from '@ngx-formly/core';
import { AsyncPipe } from '@angular/common';
import { MatSelectSearchComponent } from 'ngx-mat-select-search';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'formly-select-with-search',
    templateUrl: 'select-with-search.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatFormField, MatLabel, MatSelect, FormsModule, ReactiveFormsModule, MatOption, MatSelectSearchComponent, AsyncPipe, MatFormFieldModule, MatSelectModule]
})
export class SelectWithSearchComponent extends FieldType implements OnInit, AfterViewInit, OnDestroy, OnChanges {
    @ViewChild(MatInput) formFieldControl: MatInput;
    @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
    @ViewChild('singleSelect', { static: true }) singleSelect: MatSelect;
    formFilterControl: UntypedFormControl = new UntypedFormControl();
    public filteredData: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
    protected originalData: any;
    protected _onDestroy = new Subject<void>();

    ngOnInit(): void {
        if (!this.to.filter) {
            this.to.filter = (term: string): any => {
                term = term?.toString() || '';
                const options: any[] = this.to.options as any[] || [];
                const filtered = options.filter(v => v.label?.toLowerCase().indexOf(term?.toLowerCase()) >= 0);
                return of(filtered);
            };
        }
        this.originalData = this.field?.templateOptions?.options;
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.setInitialValue();
        }, 1000);
    }

    ngOnDestroy(): void {
        this._onDestroy.next(null);
        this._onDestroy.complete();
    }

    ngOnChanges(changes: SimpleChanges): void {

    }

    protected setInitialValue(): any {
        if (!this.originalData) {
            this.originalData = this.field?.templateOptions?.options;
            this.ngOnChanges({});
        }
        this.filteredData
            .pipe(take(0), takeUntil(this._onDestroy))
            .subscribe(() => {
                this.singleSelect.compareWith = (a: any, b: any): any => a && b && a.id === b.id;
            });
    }

    protected filterMyOptions($event): any {
        if (!this.originalData) {
            return;
        }
        let search = this.formFilterControl.value;
        if (!search) {
            this.filteredData.next(this.originalData.slice());
            return;
        } else {
            search = search?.toLowerCase();
        }
        this.filteredData.next(
            this.originalData.filter(item => item.label?.toLowerCase().indexOf(search) > -1)
        );
    }
}
